import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitTaskQueueModel } from '@apps-common/types/portal/unit-tasks'

export const deleteUnitTaskQueue = async (model: IUnitTaskQueueModel): Promise<boolean> =>
  axios.delete(`/management/UnitProgramTask/DeleteTaskQueue?id=${model.id}`).then((res) => res?.data?.data)

type Props = {
  model: IUnitTaskQueueModel
}

export const useManagementDeleteUnitTaskQueue = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['deleteUnitTaskQueue'],
    mutationFn: ({ model }: Props) => deleteUnitTaskQueue(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Deleted queue item.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to delete queue item. Can only delete queue items that have the status of "pending", "failed" or "cancelled".')
      }
    },
    throwOnError: false
  })
